import React from "react";
import GitHubCalendar from "react-github-calendar";

export const Github = () => {
  const theme = {
    dark: ["#ffffff", "#e5c2ff", "#d39eff", "#b667ff", "#7a1fa2"],
  };

  return (
    <div className="github-container">
      <h2 style={{ textAlign: "center", margin: "0px 0px 20px 0px" }}>
        GitHub Contributions
      </h2>
      <GitHubCalendar
        username="tayyab-rajja"
        year={2023}
        blockSize={15}
        blockMargin={5}
        hideTotalCount={false}
        hideColorLegend={false}
        tooltipDataAttrs={(day) => ({
          "data-tip": `${day.count} contributions on ${day.date}`,
        })}
      />
    </div>
  );
};
